"use client";

import {Flex} from "@styled-system/jsx";
import Link from "next/link";

import {JindoWhiteWithSplashIcon} from "@/components/icon";

export const JindoPrimaryLayout = () => {
    return (
        <Flex direction={"column"} justify={"center"} align={"center"} style={{marginTop: 40}}>
            <Link href="https://www.playjindo.com" target="_blank">
                <JindoWhiteWithSplashIcon style={{height: 129, width: 129}} />
            </Link>
        </Flex>
    );
};
